// PrintAssemble.js
export function buildPrintPhisoHTML({ formValues, patientData, physioTherapyData }) {
  const f = formValues;

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>PT Assessment - ${f.ptName || ""}</title>
      <style>
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: Georgia, serif; font-size: 13px; color: #111; padding: 32px; }
        h2 { text-align: center; font-size: 17px; text-decoration: underline; letter-spacing: 1px; margin-bottom: 20px; }
        .row { display: flex; gap: 24px; align-items: flex-end; border-bottom: 1px dashed #aaa; padding-bottom: 8px; margin-bottom: 10px; flex-wrap: wrap; }
        .field { display: flex; align-items: flex-end; gap: 6px; }
        .field label { font-weight: bold; white-space: nowrap; font-size: 12px; }
        .field .val { border-bottom: 1px solid #333; min-width: 80px; padding: 0 4px 1px; font-size: 13px; }
        .field .val.wide { min-width: 200px; }
        .field .val.xwide { min-width: 300px; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 14px; }
        table td { border: 1px solid #555; padding: 6px 8px; vertical-align: top; font-size: 13px; }
        table td.lbl { font-weight: bold; background: #f5f5f5; width: 160px; white-space: nowrap; }
        .signatures { display: flex; justify-content: space-between; margin-top: 48px; padding-top: 16px; border-top: 1px solid #aaa; }
        .sig-box { text-align: center; }
        .sig-line { width: 160px; border-bottom: 1px solid #333; height: 32px; margin-bottom: 4px; }
        .sig-label { font-size: 12px; font-weight: bold; }
        .body-img { display: flex; justify-content: center; margin: 14px 0; }
        body-img img { width: 500px; }
        @media print {
          body { padding: 16px; }
        }
      </style>
    </head>
    <body>
      <h2>Physical Therapy Outpatient Assessment</h2>

      <div class="row">
        <div class="field"><label>Name:</label><span class="val wide">${f.ptName || ""}</span></div>
        <div class="field"><label>Age:</label><span class="val">${f.ptAge || ""}</span></div>
        <div class="field"><label>Gender:</label><span class="val">${Array.isArray(f.ptGender) ? f.ptGender.join(", ") : f.ptGender || ""}</span></div>
        <div class="field"><label>Date:</label><span class="val">${f.ptDate || ""}</span></div>
      </div>

      <div class="row">
        <div class="field"><label>Diagnosis:</label><span class="val wide">${f.ptDiagnosis || ""}</span></div>
        <div class="field"><label>Phone:</label><span class="val">${f.ptPhone || ""}</span></div>
      </div>

      <div class="row">
        <div class="field"><label>Past History:</label><span class="val xwide">${f.ptPastHistory || ""}</span></div>
      </div>

      <div class="row">
        <div class="field"><label>Chief Complain:</label><span class="val xwide">${f.ptChiefComplain || ""}</span></div>
      </div>

      <div class="row">
        <div class="field"><label>Job &amp; Occupation:</label><span class="val xwide">${f.ptJob || ""}</span></div>
      </div>

      <div class="row">
        <div class="field"><label>Pain Score:</label><span class="val">${f.ptPainScore || ""}</span><span>/10</span></div>
        <div class="field"><label>Pain Distribution:</label><span class="val wide">${f.ptPainDistribution || ""}</span></div>
        <div class="field"><label>Lymphatic Edema:</label><span class="val">${Array.isArray(f.ptLymphaticEdema) ? f.ptLymphaticEdema.join(", ") : f.ptLymphaticEdema || ""}</span></div>
      </div>

      <div class="row">
        <div class="field"><label>Radio Investigations:</label><span class="val xwide">${f.ptRadioInvestigations || ""}</span></div>
      </div>

      <div class="row">
        <div class="field"><label>Lab Notes:</label><span class="val">${Array.isArray(f.ptLabNotes) ? f.ptLabNotes.join(", ") : f.ptLabNotes || ""}</span></div>
        <div class="field"><label>Results:</label><span class="val wide">${f.ptLabResults || ""}</span></div>
      </div>

      <div class="row">
        <div class="field"><label>Precautions:</label><span class="val xwide">${f.ptPrecautions || ""}</span></div>
      </div>

      <div class="body-img">
        <img src="/phisoImg.png" width="500" alt="Body diagram" />
      </div>

      <table>
        <tbody>
          <tr><td class="lbl">PT Assessment</td><td>${(f.ptAssessment || "").replace(/\n/g, "<br/>")}</td></tr>
          <tr><td class="lbl">PT Plan of Treatment</td><td>${(f.ptPlanOfTreatment || "").replace(/\n/g, "<br/>")}</td></tr>
          <tr>
            <td class="lbl">Sessions Num</td>
            <td>${Array.isArray(f.ptSessionsNum) ? f.ptSessionsNum.join(", ") : f.ptSessionsNum || ""}</td>
          </tr>
          <tr><td class="lbl">Progress Notes</td><td>${(f.ptProgressNotes || "").replace(/\n/g, "<br/>")}</td></tr>
        </tbody>
      </table>

      <div class="row"><div class="field"><label>TTT Goals:</label><span class="val xwide">${f.ptTttGoals || ""}</span></div></div>
      <div class="row"><div class="field"><label>Discharge:</label><span class="val xwide">${f.ptDischarge || ""}</span></div></div>
      <div class="row"><div class="field"><label>Any Other Notes:</label><span class="val xwide">${f.ptOtherNotes || ""}</span></div></div>

      <div class="signatures">
        <div class="sig-box"><div class="sig-line"></div><div class="sig-label">P.T Specialist Signature</div></div>
        <div class="sig-box"><div class="sig-line"></div><div class="sig-label">Consultant Signature</div></div>
      </div>
    </body>
    </html>
  `;
}